@if (justCompleted()) {
  <div class="survey-banner completed">
    <img
      [src]="isDark() ? '/survey-light.svg' : '/survey.svg'"
      alt=""
      aria-hidden="true"
      class="icon"
      loading="lazy"
    />
    <span class="text">Vielen Dank für dein Feedback!</span>
  </div>
} @else if (!isCompleted()) {
  <button class="survey-banner" (click)="onSurveyClick()">
    <img
      [src]="isDark() ? '/survey-light.svg' : '/survey.svg'"
      alt=""
      aria-hidden="true"
      class="icon"
      loading="lazy"
    />
    <span class="text">
      Du möchtest noch bessere Analysen? Gib uns dein Feedback!
      <span class="cta">Zur&nbsp;Umfrage&nbsp;→</span>
    </span>
  </button>
  @if (isModalOpen()) {
    <app-iframe-modal
      [url]="surveyUrl"
      (closed)="isModalOpen.set(false)"
      (completed)="onSurveyComplete()"
    ></app-iframe-modal>
  }
}
